<script setup>
const modelValue = defineModel({
  type: Boolean,
  default: false,
});
</script>

<template>
  <div>
    <input v-model="modelValue" type="checkbox" />
    {{ $t('ATTRIBUTES_MGMT.REQUIRED_ON_RESOLVE.LABEL') }}
  </div>
</template>
